<template>
    <button id="MUTE" name="MUTE" class="btn" data-vcode="MUTE" disabled :aria-label="`${$t('muteButton')}`">
        <img src="/images/icons/mute.svg" alt="" />
        <label aria-hidden="true">{{ $t('muteButton') }}</label>
    </button>
</template>
<script>
export default {};
</script>
